"use client"

import type { MouseEvent } from "react"
import NextLink from "next/link"
import { useLoadingStore } from "@/stores/loading-store"

import { useBookId } from "@/hooks/use-book-id"

export function Link({
  href,
  onClick,
  bookIdOverride,
  ...props
}: { href: string; bookIdOverride?: string } & React.ComponentProps<typeof NextLink>) {
  const currentBookId = useBookId()
  const bookId = bookIdOverride ?? currentBookId
  const setLoading = useLoadingStore((state) => state.setLoading)

  const prefix = bookId === "" ? "" : `/${bookId}`
  const newHref = href.startsWith("/") ? `${prefix}${href}` : `${prefix}/${href}`

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event)
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return
    }
    setLoading(true, newHref)
  }

  return <NextLink href={newHref} onClick={handleClick} {...props} />
}
